// extracted by mini-css-extract-plugin
export default {"opponentRunsInput":"RunsByInning_opponentRunsInput__-oB8C"};